import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon", "button"]

  connect() {
    // Set initial state
    this.isOpen = false
  }

  toggle() {
    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.contentTarget.classList.remove("hidden")
    this.iconTarget.style.transform = "rotate(180deg)"
    this.buttonTarget.setAttribute("aria-expanded", "true")
    this.isOpen = true
  }

  close() {
    this.contentTarget.classList.add("hidden")
    this.iconTarget.style.transform = "rotate(0deg)"
    this.buttonTarget.setAttribute("aria-expanded", "false")
    this.isOpen = false
  }
}